import React from 'react';
import { useHistory } from 'react-router-dom';
import DashboardCard from 'ui/DashboardCard/DashboardCard';
import NavigationTitle, { LayoutType } from 'ui/NavigationTitle/NavigationTitle';
import content from './content';
import ContactCard from './ContactCard';

import styles from './ContactUs.module.css';

const ContactUs = () => {
  const history = useHistory();
  const goBack = () => history.goBack();

  return (
    <DashboardCard>
      <NavigationTitle to="/contact-us" onClick={goBack} layoutType={LayoutType.dashboard}>
        Contact Us
      </NavigationTitle>
      <div className={styles.content}>
        {content.map((props) => (
          <ContactCard key={props.header} {...props} />
        ))}
      </div>
    </DashboardCard>
  );
};

export default ContactUs;
